import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import FormDrawerWrapper from '../../../features/components/FormDrawerWrapper'
import CampaignBudgetEditFormContent from './CampaignBudgetEditFormContent'

import useManageDrawer from '../../../hooks/formHooks/useManageDrawer'

import {
  combinedCampaignsIsLoadingSelector,
  combinedCampaignsSelector,
  combinedLineItemsIsLoadingSelector
} from '../../../modules/selectors/combinedData'

import { COMBINED_CAMPAIGN_EDIT } from '../../../constants/forms'

const CombinedCampaignBudgetEdit = () => {
  const combinedCampaigns = useSelector(combinedCampaignsSelector)
  const combinedCampaignsIsLoading = useSelector(combinedCampaignsIsLoadingSelector)
  const combinedLineItemsIsLoading = useSelector(combinedLineItemsIsLoadingSelector)

  const { campaigns = [] } = combinedCampaigns

  const { selectedEditItemId } = useManageDrawer({
    formName: COMBINED_CAMPAIGN_EDIT
  })
  const selectedCampaign = campaigns.find(campaign => String(campaign.id) === String(selectedEditItemId))

  const isEditDataLoading = useMemo(() => {
    return combinedCampaignsIsLoading || combinedLineItemsIsLoading
  }, [combinedCampaignsIsLoading, combinedLineItemsIsLoading])

  return (
    <FormDrawerWrapper title="Update campaign" formName={COMBINED_CAMPAIGN_EDIT} showOpenButton={false}>
      <CampaignBudgetEditFormContent campaign={selectedCampaign} isEditDataLoading={isEditDataLoading} />
    </FormDrawerWrapper>
  )
}

export default CombinedCampaignBudgetEdit
